import { render, staticRenderFns } from "./QuickbookConfigration.vue?vue&type=template&id=0d531c9b&"
import script from "./QuickbookConfigration.vue?vue&type=script&lang=js&"
export * from "./QuickbookConfigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports